import type {GridColDef} from '@mui/x-data-grid';
import type {ProgramAdmissionRead} from 'api/v2';
import moment from 'moment';
import {GroupListCell} from './GroupListCell';
interface AddToGroupColumnList {
  name: GridColDef<ProgramAdmissionRead>;
  groups: GridColDef<ProgramAdmissionRead>;
  startDate: GridColDef<ProgramAdmissionRead>;
}

export const addToGroupColumns: AddToGroupColumnList = {
  name: {
    field: 'member__name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
    valueGetter: ({row}) => {
      return row.member.name;
    },
  },
  groups: {
    field: 'member__groups',
    headerName: 'Groups',
    flex: 1,
    sortable: false,
    renderCell: ({row}) => <GroupListCell groupIds={row.member.groups} />,
  },
  startDate: {
    field: 'startDate',
    headerName: 'Program Start Date',
    minWidth: 150,
    flex: 0.5,
    valueFormatter: ({value}) => moment(value).format('MMM D, YYYY'),
  },
};
